import { render } from "./LBLoading.vue?vue&type=template&id=9376cf10"
import script from "./LBLoading.vue?vue&type=script&lang=js"
export * from "./LBLoading.vue?vue&type=script&lang=js"

import "./LBLoading.vue?vue&type=style&index=0&id=9376cf10&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__